export default "__VITE_ASSET__InQhZYHA__"